// import {
//   Backdrop,
//   Box,
//   Button,
//   Checkbox,
//   CircularProgress,
//   FormControlLabel,
//   Grid2,
//   Paper,
//   TextField,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import clock from "../../assets/clock.png";
// import user from "../../assets/users.png";
// import {
//   cancelReservation,
//   getReservationDetails,
//   getWidgetSettings,
// } from "../../api/HorecaWidget.service";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setLanguageWords,
//   setReservationDetail,
// } from "../../store/slice/Addguest.slice";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import dayjs from "dayjs";
// import advancedFormat from "dayjs/plugin/advancedFormat";
// import { updateCss, updateWidgetSetting } from "../../store/slice/widgetSetting.slice";
// import { STATUSTYPEIDS } from "../../constants/moduleTypes";

// const CancelReservation = () => {
//   const theme = useTheme();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const moduleId=queryParams.get('mainModuleId')
//   const{css}=useSelector((store)=> store?.widgetSettings)
//   const Css = css?.find((item) => item?.cssTabFieldsGroupName === "Success and cancel")?.fields;
//   const key = queryParams.get("key");
//   const secretKey = queryParams.get("secretkey");
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState();
//   const [isFetching, setIsFetching] = useState(false);
//   const { ReservationDetail } = useSelector((store) => store?.addGuest);
//   const [reasonError, setReasonError] = useState(false);
//   const { WidgetSetting, widgetConfig } = useSelector(
//     (store) => store?.widgetSettings
//   );
//   const { languageWords } = useSelector((store) => store?.addGuest);
//   const [isChecked, setIsChecked] = useState(true);
//   const [error, setError] = useState(false);
//   const [reason, setReason] = useState("");
//   const DATE = dayjs(ReservationDetail?.arrivalDate).format("DD-MM-YYYY");
//   const originalDate = dayjs(DATE, "DD-MM-YYYY");

//   const day = originalDate.date();
//   const month = originalDate.month() + 1;
//   const year = originalDate.year();
//   const map = {
//     1: languageWords?.January,
//     2: languageWords?.February,
//     3: languageWords?.March,
//     4: languageWords?.April,
//     5: languageWords?.May,
//     6: languageWords?.June,
//     7: languageWords?.July,
//     8: languageWords?.August,
//     9: languageWords?.September,
//     10: languageWords?.October,
//     11: languageWords?.November,
//     12: languageWords?.December,
//   };
//   const grandTotal =
//     (Number(ReservationDetail?.adults) || 0) +
//     (Number(ReservationDetail?.kid) || 0) +
//     (Number(ReservationDetail?.child) || 0) +
//     (Number(ReservationDetail?.toddler) || 0) +
//     (Number(ReservationDetail?.baby) || 0);
//   const formattedDate = `${day} ${map[month]} ${year}`;

//   const dispatch = useDispatch();
//   const fetchReservation = async () => {
//     setIsFetching(true);
//     try {
//       const response = await getReservationDetails(key, secretKey,moduleId);
//       if (response?.status != 200) {
//         setError(true);
//         throw new Error("Failed to fetch reservation details");
//       } else {
//         const result = response?.data?.basicLanguages?.reduce((acc, item) => {
//           const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
//           const data = item.widgetTranslateLanguages[0]?.name;
//           acc[tag] = data; // Assign data to the key acc[tag]
//           return acc;
//         }, {});
//         dispatch(updateCss(response?.data?.settings?.cssGroup))
//         dispatch(setLanguageWords(result));
//         dispatch(setReservationDetail(response?.data));
//       }
//     } catch (error) {
//       setIsFetching(false);
//       console.error("Error fetching reservation details:", error?.message);
//     }
//   };
//   const fetchWidgetSettings = async (language) => {
//     try {
//       const response = await getWidgetSettings(language, key);
//       if (response?.status != 200 || !response?.data) {
//         throw new Error("Failed to fetch widget settings");
//       }
//       dispatch(updateWidgetSetting(response?.data));
//       setIsFetching(false);
//     } catch (error) {
//       setIsFetching(false);
//       console.error("Error fetching widget settings:", error?.message);
//     }
//   };
//   const handleCancelReservation = async () => {
//     if (!reason.trim()) {
//       setReasonError(true);
//       return;
//     }

//     setReasonError(false);
//     setIsLoading(true);

//     const payload = {
//       key: key,
//       secretKey: secretKey,
//       remarks: reason,
//     };

//     try {
//       const response = await cancelReservation(key, secretKey, payload);
//       if (response?.status == 200) {
//         navigate("/ReservationCancelSuccess");
//       } else {
//         alert("Error canceling reservation");
//       }
//     } catch (error) {
//       console.error("Error canceling reservation:", error?.message);
//     }

//     setIsLoading(false);
//   };


//   const send = (
//     frameHeight,
//     frameWidth,
//     top,
//     right,
//     bottom,
//     left,
//     floating,
//     redirectUrl
//   ) => {
//     window.parent.postMessage(
//       {
//         reservationIframeHeight: frameHeight,
//         reservationIframeWidth: frameWidth,
//         reservationIframePositionTop: top,
//         reservationIframePositionRight: right,
//         reservationIframePositionBottom: bottom,
//         reservationIframePositionLeft: left,
//         reservationIframePositionFloating: floating,
//         redirectUrl: redirectUrl,
//       },
//       "*"
//     );
//   };

//   useEffect(() => {
//     let parentUrl = document.referrer;
//     if (!parentUrl) {
//       const { origin, pathname, search, hash } = window.location;
//       parentUrl = `${origin}${pathname}${search}${hash}`;
//     }

//     localStorage.setItem("parentUrl", parentUrl);
//   }, []);
//   useEffect(() => {
//     document.body.setAttribute(
//       "style",
//       "background-color:  rgb(249, 249, 249) !important"
//     );
//     fetchReservation();
//   }, []);
//   useEffect(() => {
//     if (ReservationDetail) {
//       fetchWidgetSettings(ReservationDetail?.language?.slice(-2));
//     }
//   }, [ReservationDetail]);

//   if (isFetching && !ReservationDetail) {
//     return (
//       <Backdrop
//         sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
//         open={isFetching}
//         onClick={() => setIsFetching(false)}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>
//     );
//   }
//   if (error) {
//     return (
//       <Box
//         sx={{
//           width: "100%",
//           p: 1,
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Box sx={{ mt: 2 }}>
//           <Typography
//             sx={{
//               color: theme?.widget?.cancelMessageColor,
//               fontWeight: "regular",
//               fontSize: "1.5rem",
//             }}
//           >
//             Failed to Fetch Cancel Reservation details.
//           </Typography>
//         </Box>
//       </Box>
//     );
//   }
//   if (ReservationDetail?.idstatus != STATUSTYPEIDS?.OPEN) {
//     return (
//       send("100vh", "100%", "", "0px", "0px", "", "fixed"),
//       (
//         <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: "#f9fafb",
//           p: 2,
//         }}
//       >
//         <Paper
//           elevation={0}
//           sx={{
//             maxWidth: 500,
//             width: "100%",
//             p: 4,
//             borderRadius: "20px",
//             textAlign: "center",
//             backgroundColor: theme?.widget?.cancelBgColorCards ?? "#fff",
//             boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
//           }}
//         >
//           <Box
//             sx={{
//               width: 70,
//               height: 70,
//               margin: "0 auto",
//               borderRadius: "50%",
//               background: "linear-gradient(135deg, #FFE8E8, #FFD6D6)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: "30px",
//             }}
//           >
//             ❌
//           </Box>
  
//           <Typography
//             sx={{
//               mt: 3,
//               fontSize: "20px",
//               fontWeight: 700,
//               color: theme?.widget?.cancelHeadingColor ?? "#111827",
//             }}
//           >
//             Cancellation Not Allowed
//           </Typography>
  
//           <Typography
//             sx={{
//               mt: 1.5,
//               fontSize: "14px",
//               color: theme?.widget?.cancelInfoColor ?? "#6B7280",
//             }}
//           >
//               This reservation cannot be cancelled at this time. 
//           Please contact the service provider directly for further assistance.
//           </Typography>
//         </Paper>
//       </Box>
//       )
   
//     );


  
//   }
//   return (
//     send("100vh", "100%", "", "0px", "0px", "", "fixed"),
//     (
//       <Box sx={{ width: "100%", p: { xs: 1, md: 3 } }}>
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             sx={{
//               fontSize: { md: "24px", sm: "12", xs: "14px" },
//               fontWeight: 700,
//               color:Css?.cancelHeading,
//             }}
//           >
//             {languageWords?.CancelReservation}
//           </Typography>

//           <Typography
//             sx={{
//               mt: 1,
//               fontSize: { md: "16px", sm: "12px", xs: "12px" },
//               color: Css?.cancelInfo,
//               maxWidth: "640px",
//             }}
//           >
//             {languageWords?.CancelInfo}
//           </Typography>
//         </Box>
//         <Grid2 container spacing={3}>
//           <Grid2 size={{ md: 6, sm: 12, xs: 12 }}>
//             <Box
//               sx={{
//                 backgroundColor: Css?.cancelYourBookingBgClr,
//                 borderRadius: "20px",
//                 border:`1px solid ${Css?.cancelYourBookingBorderClr}`,
//                 p: 3,
//                 boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontSize: "20px",
//                   fontWeight: 600,
//                   color: Css?.cancelYourBookingHeadingClr,
//                 }}
//               >
//                 {languageWords?.yourBooking}
//               </Typography>

//               <Box sx={{ mt: 2 }}>
//                 <Typography sx={{ fontSize: "22px", fontWeight: 600,color: Css?.cancelYourBookingAddressHeadingClr}}>
//                   {
//                     WidgetSetting?.find((item) => item?.tag === "companyName")
//                       ?.data
//                   }
//                 </Typography>
//                 <Typography
//                   sx={{ color: Css?.cancelYourBookingAddressInfoClr, fontSize: "13px" }}
//                 >
//                   {
//                     WidgetSetting?.find(
//                       (item) => item?.tag === "companyAddress"
//                     )?.data
//                   }
//                   ,{" "}
//                   {
//                     WidgetSetting?.find((item) => item?.tag === "companyCity")
//                       ?.data
//                   }
//                 </Typography>
//               </Box>

//               {/* Meta Info */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   gap: 3,
//                   alignItems: "center",
//                   mt: 3,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <img src={clock} alt="time" width={24} />
//                   <Typography
//                     sx={{ color: Css?.cancelDateTimeClr }}
//                   >
//                     {formattedDate}{" "}
//                     {ReservationDetail?.arrivalTime?.substring(0, 5)}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <img src={user} alt="user" width={24} />
//                   <Typography sx={{ color:Css?.cancelCountClr }}>
//                     {grandTotal}
//                   </Typography>
//                 </Box>
//               </Box>

//               {/* Price */}
//               {ReservationDetail?.reservationPrice && (
//                 <Box
//                   sx={{
//                     mt: 4,
//                     p: 2,
//                     borderRadius: "14px",
//                     background: "linear-gradient(135deg, #FFF5EC, #FFE4D2)",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontWeight: 600,
//                       color: Css?.cancelReservationPriceClr,
//                     }}
//                   >
//                     {ReservationDetail?.reservationType?.name}
//                   </Typography>
//                   <Typography sx={{ fontWeight: 700, color: Css?.cancelReservationPriceClr }}>
//                     €{" "}
//                     {parseFloat(
//                       ReservationDetail?.reservationType?.maxamount
//                     ).toFixed(2)}
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           </Grid2>
//           <Grid2 size={{ md: 6, sm: 12, xs: 12 }}>
//             <Box
//               sx={{
//                 backgroundColor: Css?.cancelGuestCardBgClr,
//                 borderRadius: "20px",
//                 border:`1px solid ${Css?.cancelBorderClr}`,
//                 p: 3,
//                 boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontSize: "20px",
//                   fontWeight: 600,
//                   color: Css?.cancelYourBookingHeadingClr,
//                 }}
//               >
//                 {languageWords?.yourDetails}
//               </Typography>

//               <Box
//                 sx={{
//                   display: "grid",
//                   gridTemplateColumns: "120px 1fr",
//                   rowGap: 1.5,
//                   mt: 3,
//                 }}
//               >
//                 <Typography fontWeight={500} sx={{color:Css?.cancelLabelText}}>{languageWords?.Name}</Typography>
//                 <Typography color={Css?.cancelGuestTextClr}>
//                   {ReservationDetail?.name}
//                 </Typography>

//                 <Typography fontWeight={500} sx={{color:Css?.cancelLabelText}}>{languageWords?.Email}</Typography>
//                 <Typography color={Css?.cancelGuestTextClr}>
//                   {ReservationDetail?.email}
//                 </Typography>

//                 <Typography fontWeight={500} sx={{color:Css?.cancelLabelText}}>{languageWords?.Phone}</Typography>
//                 <Typography color={Css?.cancelGuestTextClr}>
//                   {ReservationDetail?.phone}
//                 </Typography>
//               </Box>
//             </Box>
//           </Grid2>
//         </Grid2>
//         <Grid2 container spacing={3} mt={2}>
//           <Grid2 size={{ md: 6, sm: 12, xs: 12 }}>
//             <TextField
//               multiline
//               rows={6}
//               fullWidth
//               value={reason}
//               placeholder={languageWords?.ReasonforCancellation}
//               onChange={(e) => {
//                 setReason(e.target.value);
//                 if (e.target.value.trim()) {
//                   setReasonError(false);
//                 }
//               }}
//               error={reasonError}
//               helperText={reasonError ? "Reason is required" : ""}
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "16px",
//                   border:`1px solid ${Css?.cancelYourBookingBorderClr}`,
                 
//                 },
//               }}
//             />
//           </Grid2>
//         </Grid2>
//         <Grid2 container spacing={2} mt={2}>
//           <Grid2 size={{ md: 12, sm: 12 }}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={isChecked}
//                   onChange={() => setIsChecked(!isChecked)}
//                   sx={{
//                     "&.Mui-checked": { color: Css?.cancelCheckboxTickColor },
//                   }}
//                 />
//               }
//               label={
//                 <Typography sx={{ color: Css?.cancelLabelCheckBoxClr}}>
//                   {languageWords?.TermsandCondtionsText}
//                 </Typography>
//               }
//             />

//             <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
//               <Button
//                 //  disabled={!isChecked}
//                 disabled={!isChecked || !reason.trim()}
//                 onClick={handleCancelReservation}
//                 sx={{
//                   px: 4,
//                   py: 1.5,
//                   borderRadius: "12px",
//                   backgroundColor: isChecked
//                     ? Css?.CancelReservationBgClr 
//                     : Css?. CancelReservationDisabledBgClr,
//                   color: isChecked
//                     ? Css?.cancelReservationTxtClr 
//                     : Css?.CancelReservationDisabledTxtClr ,
//                   fontWeight: 600,
                 
//                 }}
//               >
//                 {isLoading ? (
//                   <CircularProgress size={22} sx={{ color: "#fff" }} />
//                 ) : (
//                   languageWords?.CancelWidgetButtonText
//                 )}
//               </Button>
//             </Box>
//           </Grid2>
//         </Grid2>
//       </Box>
//     )
//   );
// };

// export default CancelReservation;


import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
  useTheme,
  Chip,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import clock from "../../assets/clock.png";
import user from "../../assets/users.png";
import {
  cancelReservation,
  getReservationDetails,
  getWidgetSettings,
} from "../../api/HorecaWidget.service";
import { useDispatch, useSelector } from "react-redux";
import {
  setLanguageWords,
  setReservationDetail,
} from "../../store/slice/Addguest.slice";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  updateCss,
  updateWidgetSetting,
} from "../../store/slice/widgetSetting.slice";
import { STATUSTYPEIDS } from "../../constants/moduleTypes";

/* ─── tiny helpers ─────────────────────────────────────────────── */
const MONTH_MAP_KEY = [
  "", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const grandTotalGuests = (d) =>
  ["adults", "kid", "child", "toddler", "baby"].reduce(
    (s, k) => s + (Number(d?.[k]) || 0),
    0
  );

/* ─── sub-components ───────────────────────────────────────────── */
const InfoRow = ({ label, value, labelColor, valueColor }) => (
  <Box
    sx={{
      display: "flex",
      gap: 1,
      py: 1,
      borderBottom: "1px dashed rgba(0,0,0,0.06)",
      "&:last-child": { borderBottom: "none" },
    }}
  >
    <Typography
      sx={{
        minWidth: 90,
        fontSize: "13px",
        fontWeight: 600,
        color: labelColor ?? "#9CA3AF",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{ fontSize: "14px", color: valueColor ?? "#111827", fontWeight: 500 }}
    >
      {value}
    </Typography>
  </Box>
);

const SectionCard = ({ children, sx = {} }) => (
  <Paper
    elevation={0}
    sx={{
      borderRadius: "18px",
      p: 3,
      height: "100%",
      background: "#fff",
      border: "1px solid rgba(0,0,0,0.07)",
      boxShadow: "0 4px 24px rgba(0,0,0,0.05)",
      transition: "box-shadow .2s",
      "&:hover": { boxShadow: "0 8px 32px rgba(0,0,0,0.09)" },
      ...sx,
    }}
  >
    {children}
  </Paper>
);

/* ─── main component ───────────────────────────────────────────── */
const CancelReservation = () => {
  const theme = useTheme();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const moduleId = queryParams.get("mainModuleId");
  const key = queryParams.get("key");
  const secretKey = queryParams.get("secretkey");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState(false);

  const { ReservationDetail } = useSelector((s) => s?.addGuest);
  const { WidgetSetting, css } = useSelector((s) => s?.widgetSettings);
  const { languageWords } = useSelector((s) => s?.addGuest);

  const Css = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Success and cancel"
  )?.fields;

  /* ── date formatting ── */
  const DATE = dayjs(ReservationDetail?.arrivalDate).format("DD-MM-YYYY");
  const orig = dayjs(DATE, "DD-MM-YYYY");
  const monthLabel = languageWords?.[MONTH_MAP_KEY[orig.month() + 1]];
  const formattedDate = `${orig.date()} ${monthLabel ?? MONTH_MAP_KEY[orig.month() + 1]} ${orig.year()}`;
  const totalGuests = grandTotalGuests(ReservationDetail);

  /* ── helpers ── */
  const widgetVal = (tag) =>
    WidgetSetting?.find((i) => i?.tag === tag)?.data ?? "";

  const send = (...args) => {
    const [fH, fW, top, right, bottom, left, floating, redirectUrl] = args;
    window.parent.postMessage(
      {
        reservationIframeHeight: fH,
        reservationIframeWidth: fW,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl,
      },
      "*"
    );
  };

  /* ── data fetching ── */
  const fetchReservation = async () => {
    setIsFetching(true);
    try {
      const response = await getReservationDetails(key, secretKey, moduleId);
      if (response?.status !== 200) {
        setError(true);
        return;
      }
      const result = response?.data?.basicLanguages?.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        acc[tag] = item.widgetTranslateLanguages[0]?.name;
        return acc;
      }, {});
      dispatch(updateCss(response?.data?.settings?.cssGroup));
      dispatch(setLanguageWords(result));
      dispatch(setReservationDetail(response?.data));
    } catch (e) {
      console.error("Error fetching reservation details:", e?.message);
    } finally {
      setIsFetching(false);
    }
  };

  const fetchWidgetSettings = async (language) => {
    try {
      const response = await getWidgetSettings(language, key);
      if (response?.status !== 200 || !response?.data) return;
      dispatch(updateWidgetSetting(response?.data));
    } catch (e) {
      console.error("Error fetching widget settings:", e?.message);
    }
  };

  const handleCancelReservation = async () => {
    if (!reason.trim()) {
      setReasonError(true);
      return;
    }
    setReasonError(false);
    setIsLoading(true);
    try {
      const response = await cancelReservation(key, secretKey, {
        key,
        secretKey,
        remarks: reason,
      });
      if (response?.status === 200) {
        navigate("/ReservationCancelSuccess");
      } else {
        alert("Error canceling reservation");
      }
    } catch (e) {
      console.error("Error canceling reservation:", e?.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* ── effects ── */
  useEffect(() => {
    const parentUrl =
      document.referrer ||
      `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
    localStorage.setItem("parentUrl", parentUrl);
  }, []);

  useEffect(() => {
    document.body.setAttribute("style", "background-color: #F7F8FA !important");
    fetchReservation();
  }, []);

  useEffect(() => {
    if (ReservationDetail) {
      fetchWidgetSettings(ReservationDetail?.language?.slice(-2));
    }
  }, [ReservationDetail]);

  /* ── states ── */
  if (isFetching && !ReservationDetail) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }}
        open={isFetching}
        onClick={() => setIsFetching(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#F7F8FA",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 5,
            borderRadius: "20px",
            textAlign: "center",
            maxWidth: 420,
            border: "1px solid #FFE4E4",
            background: "#FFF8F8",
          }}
        >
          <Box sx={{ fontSize: "48px", mb: 2 }}>⚠️</Box>
          <Typography sx={{ fontWeight: 700, fontSize: "18px", color: "#DC2626", mb: 1 }}>
            Unable to Load Reservation
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#6B7280" }}>
            Failed to fetch reservation details. Please try again or contact support.
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (ReservationDetail?.idstatus !== STATUSTYPEIDS?.OPEN) {
    send("100vh", "100%", "", "0px", "0px", "", "fixed");
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #FFF5F5 0%, #FFF0E8 100%)",
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            maxWidth: 460,
            width: "100%",
            p: 5,
            borderRadius: "24px",
            textAlign: "center",
            background: Css?.cancelBgColorCards ?? "#fff",
            boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              margin: "0 auto",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #FFE8E8, #FFD0D0)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "32px",
              mb: 3,
            }}
          >
            🚫
          </Box>
          <Typography sx={{ fontSize: "22px", fontWeight: 700, color: Css?.cancelHeadingColor ?? "#111827", mb: 1.5 }}>
            Cancellation Not Allowed
          </Typography>
          <Typography sx={{ fontSize: "14px", color: Css?.cancelInfoColor ?? "#6B7280", lineHeight: 1.7 }}>
            This reservation cannot be cancelled at this time. Please contact the service provider directly for further assistance.
          </Typography>
        </Paper>
      </Box>
    );
  }

  /* ── main UI ── */
  send("100vh", "100%", "", "0px", "0px", "", "fixed");

  const canSubmit = isChecked && reason.trim();

  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: "auto",
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 3, md: 5 },
      }}
    >
      {/* ── Header ── */}
      <Box sx={{ mb: 4 }}>
        <Chip
          label="⚠️ Action Required"
          size="small"
          sx={{
            mb: 1.5,
            background: "#FFF3CD",
            color: "#92400E",
            fontWeight: 600,
            fontSize: "11px",
            letterSpacing: "0.05em",
            border: "1px solid #FDE68A",
          }}
        />
        <Typography
          sx={{
            fontSize: { xs: "22px", md: "28px" },
            fontWeight: 800,
            color: Css?.cancelHeading ?? "#111827",
            lineHeight: 1.2,
            letterSpacing: "-0.02em",
          }}
        >
          {languageWords?.CancelReservation ?? "Cancel Reservation"}
        </Typography>
        <Typography
          sx={{
            mt: 1,
            fontSize: "15px",
            color: Css?.cancelInfo ?? "#6B7280",
            maxWidth: 560,
            lineHeight: 1.6,
          }}
        >
          {languageWords?.CancelInfo ?? "Please review your booking details before proceeding with the cancellation."}
        </Typography>
      </Box>

      {/* ── Two-column cards ── */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 3,
          mb: 3,
        }}
      >
        {/* Booking Card */}
        <SectionCard sx={{ background: Css?.cancelYourBookingBgClr, borderColor: Css?.cancelYourBookingBorderClr }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "10px",
                background: "linear-gradient(135deg, #FFF0E0, #FFD9B0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
              }}
            >
              🏨
            </Box>
            <Typography sx={{ fontSize: "16px", fontWeight: 700, color: Css?.cancelYourBookingHeadingClr ?? "#111827" }}>
              {languageWords?.yourBooking ?? "Your Booking"}
            </Typography>
          </Box>

          <Typography sx={{ fontSize: "20px", fontWeight: 700, color: Css?.cancelYourBookingAddressHeadingClr ?? "#111827", mb: 0.5 }}>
            {widgetVal("companyName")}
          </Typography>
          <Typography sx={{ fontSize: "13px", color: Css?.cancelYourBookingAddressInfoClr ?? "#9CA3AF", mb: 3 }}>
            {widgetVal("companyAddress")}, {widgetVal("companyCity")}
          </Typography>

          <Divider sx={{ mb: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: "10px",
                background: "rgba(0,0,0,0.03)",
                border: "1px solid rgba(0,0,0,0.06)",
              }}
            >
              <img src={clock} alt="time" width={16} />
              <Typography sx={{ fontSize: "13px", fontWeight: 600, color: Css?.cancelDateTimeClr ?? "#374151" }}>
                {formattedDate} · {ReservationDetail?.arrivalTime?.substring(0, 5)}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: "10px",
                background: "rgba(0,0,0,0.03)",
                border: "1px solid rgba(0,0,0,0.06)",
              }}
            >
              <img src={user} alt="guests" width={16} />
              <Typography sx={{ fontSize: "13px", fontWeight: 600, color: Css?.cancelCountClr ?? "#374151" }}>
                {totalGuests} {totalGuests === 1 ? "Guest" : "Guests"}
              </Typography>
            </Box>
          </Box>

          {ReservationDetail?.reservationPrice && (
            <Box
              sx={{
                mt: 3,
                p: 2,
                borderRadius: "14px",
                background: "linear-gradient(135deg, #FFF7ED, #FFEDD5)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #FED7AA",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "14px", color: Css?.cancelReservationPriceClr ?? "#92400E" }}>
                {ReservationDetail?.reservationType?.name}
              </Typography>
              <Typography sx={{ fontWeight: 800, fontSize: "18px", color: Css?.cancelReservationPriceClr ?? "#92400E" }}>
                € {parseFloat(ReservationDetail?.reservationType?.maxamount).toFixed(2)}
              </Typography>
            </Box>
          )}
        </SectionCard>

        {/* Guest Card */}
        <SectionCard sx={{ background: Css?.cancelGuestCardBgClr, borderColor: Css?.cancelBorderClr }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "10px",
                background: "linear-gradient(135deg, #EEF2FF, #C7D2FE)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
              }}
            >
              👤
            </Box>
            <Typography sx={{ fontSize: "16px", fontWeight: 700, color: Css?.cancelYourBookingHeadingClr ?? "#111827" }}>
              {languageWords?.yourDetails ?? "Your Details"}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <InfoRow
              label={languageWords?.Name ?? "Name"}
              value={ReservationDetail?.name}
              labelColor={Css?.cancelLabelText}
              valueColor={Css?.cancelGuestTextClr}
            />
            <InfoRow
              label={languageWords?.Email ?? "Email"}
              value={ReservationDetail?.email}
              labelColor={Css?.cancelLabelText}
              valueColor={Css?.cancelGuestTextClr}
            />
            <InfoRow
              label={languageWords?.Phone ?? "Phone"}
              value={ReservationDetail?.phone}
              labelColor={Css?.cancelLabelText}
              valueColor={Css?.cancelGuestTextClr}
            />
          </Box>
        </SectionCard>
      </Box>

      {/* ── Reason textarea ── */}
      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: Css?.cancelHeading ?? "#374151",
            mb: 1,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          {languageWords?.ReasonforCancellation ?? "Reason for Cancellation"}
          <Typography component="span" sx={{ color: "#EF4444", ml: 0.5 }}>*</Typography>
        </Typography>

        <TextField
          multiline
          rows={5}
          fullWidth
          value={reason}
          placeholder={languageWords?.ReasonforCancellation ?? "Please describe why you are cancelling this reservation…"}
          onChange={(e) => {
            setReason(e.target.value);
            if (e.target.value.trim()) setReasonError(false);
          }}
          error={reasonError}
          helperText={reasonError ? "A reason is required to proceed with the cancellation." : ""}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "14px",
              fontSize: "14px",
              background: "#fff",
              "& fieldset": {
                borderColor: reasonError ? "#EF4444" : (Css?.cancelYourBookingBorderClr ?? "rgba(0,0,0,0.12)"),
                borderWidth: "1.5px",
              },
              "&:hover fieldset": {
                borderColor: Css?.cancelYourBookingBorderClr ?? "rgba(0,0,0,0.25)",
              },
              "&.Mui-focused fieldset": {
                borderColor: Css?.CancelReservationBgClr ?? "#6366F1",
                borderWidth: "2px",
              },
            },
            "& .MuiFormHelperText-root": {
              fontSize: "12px",
              mt: 0.75,
              color: "#EF4444",
            },
          }}
        />
      </Box>

      {/* ── Footer: checkbox + button ── */}
      <Box
        sx={{
          p: 3,
          borderRadius: "16px",
          background: "#fff",
          border: "1px solid rgba(0,0,0,0.07)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
          boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={() => setIsChecked((v) => !v)}
              sx={{
                color: "rgba(0,0,0,0.2)",
                "&.Mui-checked": {
                  color: Css?.cancelCheckboxTickColor ?? "#6366F1",
                },
              }}
            />
          }
          label={
            <Typography sx={{ fontSize: "13px", color: Css?.cancelLabelCheckBoxClr ?? "#374151" }}>
              {languageWords?.TermsandCondtionsText ?? "I agree to the terms and conditions of this cancellation."}
            </Typography>
          }
        />

        <Button
          disabled={!canSubmit}
          onClick={handleCancelReservation}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: "12px",
            minWidth: 180,
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "none",
            letterSpacing: "0.01em",
            background: canSubmit
              ? (Css?.CancelReservationBgClr ?? "linear-gradient(135deg, #EF4444, #DC2626)")
              : (Css?.CancelReservationDisabledBgClr ?? "#F3F4F6"),
            color: canSubmit
              ? (Css?.cancelReservationTxtClr ?? "#fff")
              : (Css?.CancelReservationDisabledTxtClr ?? "#9CA3AF"),
            boxShadow: canSubmit ? "0 4px 14px rgba(220,38,38,0.3)" : "none",
            transition: "all 0.2s ease",
            "&:hover": {
              background: canSubmit
                ? (Css?.CancelReservationBgClr ?? "#DC2626")
                : (Css?.CancelReservationDisabledBgClr ?? "#F3F4F6"),
              boxShadow: canSubmit ? "0 6px 20px rgba(220,38,38,0.4)" : "none",
              transform: canSubmit ? "translateY(-1px)" : "none",
            },
            "&:disabled": {
              background: Css?.CancelReservationDisabledBgClr ?? "#F3F4F6",
              color: Css?.CancelReservationDisabledTxtClr ?? "#9CA3AF",
            },
          }}
        >
          {isLoading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            languageWords?.CancelWidgetButtonText ?? "Cancel Reservation"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default CancelReservation;
